var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    transform: "scale(.6)",
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ae0a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72134b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1276 -24)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 5,
    transform: "translate(1276 24)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.024,26.218a.764.764,0,0,1-.369.6,3.122,3.122,0,0,1-1.136.451q-.767.177-1.574.328a17.9,17.9,0,0,1-2.066.233q-1.259.082-2.19.123t-2.395.069q-1.464.027-2.217.027H11.945l-2.217-.027-2.395-.069-2.19-.123L3.078,27.6,1.5,27.272.369,26.82,0,26.218q.055-2.409,3.01-4.255a18.693,18.693,0,0,1,7.5-2.45v-.9a7.233,7.233,0,0,1-2.463-1.779,8.64,8.64,0,0,1-1.642-2.7,15.805,15.805,0,0,1-.876-3.312,24.9,24.9,0,0,1-.274-3.817,6.883,6.883,0,0,1,.684-3.12,5.764,5.764,0,0,1,1.888-2.2A8.919,8.919,0,0,1,10.59.424,12.981,12.981,0,0,1,14.012,0a13.059,13.059,0,0,1,3.421.424A8.882,8.882,0,0,1,20.2,1.683a5.771,5.771,0,0,1,1.888,2.2,6.891,6.891,0,0,1,.684,3.12q0,9.579-5.254,11.659v.849a18.684,18.684,0,0,1,7.5,2.449Q27.968,23.809,28.024,26.218Z",
    transform: "translate(1287 35) ",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogo);
export default __webpack_public_path__ + "static/media/userLogo.da7b70c9f2227be47b74c69c05bf15d1.svg";
export { ForwardRef as ReactComponent };